(function () {
    'use strict';

    angular
        .module('HRConfirmationsControllers')
        .controller('HRConfirmationsController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$sce', '$q', '$state', '$modal', '$translate', 'topBar', 'employeeSyncService', 'authenticatedUser', 'latestClosedBatch', 'notConfirmedMatchings', 'matchingRules'];

    function Controller($rootScope, $scope, $sce, $q, $state, $modal, $translate, topBar, employeeSyncService, authenticatedUser, latestClosedBatch, notConfirmedMatchings, matchingRules) {

        //topBar.setTitleAndIcon('Synchronization', 'fa fa-refresh');

        // Load translations asynchronously to avoid race condition
        $q.all({
            humanResources: $translate('iam.hr.confirmations.breadcrumb.humanResources'),
            synchronization: $translate('iam.hr.confirmations.breadcrumb.synchronization')
        }).then(function(translations) {
            topBar.setTitle($sce.trustAsHtml(
                '<span style="color: #777">' + translations.humanResources + '</span>&nbsp;' +
                '<i style="color: #777" class="fa fa-chevron-right"></i>&nbsp;' +
                '<i class="fa fa-refresh"></i>&nbsp;' +
                '<span>' + translations.synchronization + '</span>'
            ));
        });

        var MAX_MatchingsAndExceptions_Per_Page = 7;

        $scope.ctrlCtxt                                  = {};
        $scope.ctrlCtxt.latestClosedBatch                = latestClosedBatch;
        $scope.ctrlCtxt.matchingRules                    = matchingRules;
        $scope.ctrlCtxt.latestBatch                      = {};
        $scope.ctrlCtxt.matchingsAndExceptions           = [];
        $scope.ctrlCtxt.maxMatchingsAndExceptionsPerPage = MAX_MatchingsAndExceptions_Per_Page;
        $scope.ctrlCtxt.selectedFacetGroup               = {};
        $scope.ctrlCtxt.selectedMatching                 = { selectedMatchingID: null };

        // Paging
        $scope.ctrlCtxt.matchingPaginationIdx      = 0;
        $scope.ctrlCtxt.matchingAndExceptionsPages = [];
        $scope.ctrlCtxt.showPaging                 = false;

        $scope.authenticatedUser         = authenticatedUser
        $scope.allMatchingsAndExceptions = [];

        // Get Batch Exceptions
        employeeSyncService
            .getExceptionsByBatchId(latestClosedBatch.PubEmp_BatchID)
            .then(function (batchExceptions) {
                $scope.allMatchingsAndExceptions = _.union(notConfirmedMatchings, batchExceptions);
            });

        // Get Items Type Title
        $scope.getItemsTypeTitle = function () {

            if (_.isUndefined($scope.ctrlCtxt.selectedFacetGroup.facetTitle)) {
                return $translate.instant('iam.hr.confirmations.messages.pendingTasksAndExceptions');
            }

            return $scope.ctrlCtxt.selectedFacetGroup.facetTitle + 's';
        };

        // Reset Matchings And Exceptions
        $scope.resetMatchingsAndExceptions = function () {
            var filteredMatchingAndExceptions = $scope.getFilteredMatchingAndExceptions();

            $scope.ctrlCtxt.matchingsAndExceptions  = _.take(filteredMatchingAndExceptions, $scope.ctrlCtxt.maxMatchingsAndExceptionsPerPage);
            $scope.matchingsAndExceptionsTotalCount = filteredMatchingAndExceptions.length;
            $scope.ctrlCtxt.showPaging              = false;
        };

        // Get Filtered Matching And Exceptions
        $scope.getFilteredMatchingAndExceptions = function () {
            if (!$scope.ctrlCtxt.selectedFacetGroup.model) return $scope.allMatchingsAndExceptions;

            return _.filter($scope.allMatchingsAndExceptions, function (matchAndExc) {
                return matchAndExc[$scope.ctrlCtxt.selectedFacetGroup.facetModel] === $scope.ctrlCtxt.selectedFacetGroup.model;
            })
        };

        // Confirm All By Matching Rule
        $scope.openBatchConfirmByRuleModal = function () {

            var modalScope = $rootScope.$new();
            modalScope.selectedFacetGroup = $scope.ctrlCtxt.selectedFacetGroup;
            modalScope.isLoading = false;

            var confirmModal = $modal({
                backdrop  : 'static',
                keyboard  : false,
                scope: modalScope,
                show: true,
                template: require('./batchConfirmByRuleModal.tpl.html'),
                placement: 'center'
            });

            modalScope.hideModal = function () {
                confirmModal.$promise.then(confirmModal.hide);
            }

            modalScope.okModal = function () {
                modalScope.hideModal();
            }

            modalScope.confirmAllByMatchingRule = function (matchingStagingRule) {
                modalScope.isLoading = true;

                employeeSyncService
                    .confirmMatchingByRule(matchingStagingRule.Name)
                    .then(function () {
                        $scope
                            .refreshMatchingsAndExceptions()
                            .then(function () {
                                modalScope.hideModal();
                            });

                    })
                    .finally(function () {
                        modalScope.isLoading = false;
                    });
            };
        };

        // Refresh Matchings And Exceptions
        $scope.refreshMatchingsAndExceptions = function () {
            $scope.allMatchingsAndExceptions = null;

            return $q
                     .all({
                         exceptions: employeeSyncService.getExceptionsByBatchId(latestClosedBatch.PubEmp_BatchID),
                         notConfirmedMatchings: employeeSyncService.getNotConfirmedAndLastMatchingStagingRecords()
                     })
                     .then(function (responses) {
                         $scope.allMatchingsAndExceptions = _.union(responses.notConfirmedMatchings, responses.exceptions);
                         $scope.resetMatchingsAndExceptions();
                     });
        };

    }
})();
